import { FC } from "react";
import { IconProps } from "./types";

export const ArrowLeftCircleFilled: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 12C0 5.4 5.4 0 12 0s12 5.4 12 12-5.4 12-12 12S0 18.6 0 12zm10.826-6a.596.596 0 0 0-.392.158l-5.402 5.447a.605.605 0 0 0-.157.395c0 .04.02.079.04.118.019.04.038.08.038.119.049 0 .067.03.093.072.015.025.034.056.064.086l5.402 5.447a.595.595 0 0 0 .392.158c.039 0 .078-.02.117-.04.04-.02.079-.039.118-.039 0-.049.03-.067.071-.093a.44.44 0 0 0 .085-.065c.079 0 .157-.079.157-.158.078-.079.078-.158.078-.237 0-.04-.02-.078-.039-.118-.02-.04-.04-.079-.04-.118-.048 0-.066-.03-.091-.072-.016-.026-.035-.056-.065-.086l-4.384-4.421h11.666a.595.595 0 0 0 .391-.158.605.605 0 0 0 .157-.395c0-.158-.078-.316-.157-.474a.596.596 0 0 0-.391-.158H6.832l4.385-4.42a.606.606 0 0 0 .157-.395.606.606 0 0 0-.157-.395C11.139 6 10.982 6 10.826 6z"
      fill={fill}
    />
  </svg>
);
